import { createPattern, escapeSelector } from '../../utils';
import { ClassObjectType } from '../../types';

// Pattern
export const pattern = createPattern(
        '(justify|align)-items-(?:(start|center|end|stretch))(\!){0,1}', 
        {breakpoints: true
    });

// Resolver
export const rules = (props): ClassObjectType => {
    const [className, breakpoint, property, value, important] = props;
    // console.log(props);
    const selector = escapeSelector(className);


    const ValueMap = {
        'start': property === 'align' ? 'flex-start' : 'start',
        'center': 'center',
        'end': property === 'align' ? 'flex-end' : 'end',
        'stretch': 'stretch'
    }
    

    const rule = {
        [selector]: {
            [`${property}-items`]: `${ValueMap[value]}${important ? ' !important' : ''}`
        }
    };

    return {
        breakpoint,
        rule
    };
    
}

export default { pattern, rules };